export default __webpack_public_path__ + "static/media/deal.ff5ed3c7.svg";